"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var rgba_1 = __importDefault(require("polished/lib/color/rgba"));
var axios_1 = __importDefault(require("axios"));
var SportsOfferTable_styles_1 = __importDefault(require("./SportsOfferTable.styles"));
var AGHits_1 = __importDefault(require("../../molecules/AGHits/AGHits"));
var TableHeadBtn_1 = __importDefault(require("../../atoms/TableHeadBtn/TableHeadBtn"));
var columnData_1 = require("../../../data/columnData");
var Modal_styles_1 = __importDefault(require("../../molecules/Modal/Modal.styles"));
var Button_1 = __importDefault(require("../../atoms/Button/Button"));
var SportsOfferTable = function () {
    var columnFilters = react_redux_1.useSelector(function (state) { return state.filters.chosenColumnFilters; });
    var _a = react_1.useState(false), modalIsOpen = _a[0], setIsOpen = _a[1];
    var _b = react_1.useState(), deleteHitID = _b[0], setDeleteHitID = _b[1];
    var tableRef = react_1.useRef(null);
    var tableHeadRef = react_1.useRef(null);
    var horScrollRef = react_1.useRef(null);
    var horScrollRefInner = react_1.useRef(null);
    var openDeleteModal = function (hitObjectID) {
        setDeleteHitID(hitObjectID);
        setIsOpen(true);
    };
    var deleteHit = function () {
        axios_1.default({
            method: 'DELETE',
            url: "/api/rosters/" + deleteHitID,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (res) {
            console.log(res);
            setIsOpen(false); // close modal
            window.location.href = "/"; // refresh page
        })
            .catch(function (error) {
            console.error(error.response.data.errors);
        });
    };
    // make tableheader sticky on scroll after passing header nav
    react_1.useEffect(function () {
        var onScroll = function () {
            if (tableRef.current && tableHeadRef.current) {
                var tableTop = tableRef.current.getBoundingClientRect().top;
                var threshold = 75; // nav height
                var scrollOffset = -tableTop + threshold;
                if (tableTop < threshold && horScrollRef.current) {
                    horScrollRef.current.style.transform = "translateY(" + scrollOffset + "px)"; // move faux scrollbar
                    tableHeadRef.current.style.transform = "translateY(" + scrollOffset + "px)"; // move table header
                }
                else if (horScrollRef.current) {
                    horScrollRef.current.style.transform = 'translateY(0)'; // reset transform
                    tableHeadRef.current.style.transform = 'translateY(0)';
                }
            }
        };
        window.addEventListener('scroll', onScroll);
        return function () {
            window.removeEventListener('scroll', onScroll);
        };
    }, [tableRef, tableHeadRef, horScrollRef]);
    // sync faux scrollbar with actual table horizontal scroll
    react_1.useEffect(function () {
        if (tableRef.current && horScrollRef.current) {
            tableRef.current.onscroll = function () {
                var _a;
                if (tableRef.current && horScrollRef.current) {
                    horScrollRef.current.scrollLeft = (_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.scrollLeft;
                }
                // make sure the faux scroll div has the same width as the table inner content
                if (tableHeadRef.current && horScrollRefInner.current) {
                    horScrollRefInner.current.style.width = tableHeadRef.current.getBoundingClientRect().width + "px";
                }
                ;
            };
            horScrollRef.current.onscroll = function () {
                var _a;
                if (tableRef.current && horScrollRef.current) {
                    tableRef.current.scrollLeft = (_a = horScrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollLeft;
                }
                // make sure the faux scroll div has the same width as the table inner content
                if (tableHeadRef.current && horScrollRefInner.current) {
                    horScrollRefInner.current.style.width = tableHeadRef.current.getBoundingClientRect().width + "px";
                }
                ;
            };
        }
    }, [tableRef, horScrollRef, horScrollRefInner, tableHeadRef]);
    return (react_1.default.createElement(SportsOfferTable_styles_1.default, null,
        react_1.default.createElement("div", { className: "table-horizontal-scroll", ref: horScrollRef },
            react_1.default.createElement("div", { className: "table-horizontal-scroll-inner", ref: horScrollRefInner })),
        react_1.default.createElement("div", { className: "table-container" },
            react_1.default.createElement("table", { className: "table", ref: tableRef },
                react_1.default.createElement("thead", { className: "table-head", ref: tableHeadRef },
                    react_1.default.createElement("tr", { className: "table-row" },
                        columnFilters &&
                            Object.keys(columnData_1.columnData).map(function (key) {
                                return columnData_1.columnData[key].data.map(function (item, index) {
                                    return !columnFilters.includes(item.name) && (react_1.default.createElement(TableHeadBtn_1.default, { key: index, label: item.label, attribute: item.name, sortAsc: !(item.name === 'day' || item.name === 'target_audience'), width: item.width ? item.width : null }));
                                });
                            }),
                        react_1.default.createElement("th", { className: "edit" }, "\u00A0"))),
                react_1.default.createElement("tbody", { className: "table-body" },
                    react_1.default.createElement(AGHits_1.default, { openDeleteModal: openDeleteModal })))),
        react_1.default.createElement(Modal_styles_1.default, { isOpen: modalIsOpen, style: {
                overlay: {
                    zIndex: 10,
                    backgroundColor: rgba_1.default(0, 0, 0, 0.25),
                },
            }, ariaHideApp: false },
            react_1.default.createElement("div", { className: "modal-inner" },
                react_1.default.createElement("h3", { className: "modal-title" }, "Weet je zeker dat je dit aanbod wil verwijderen"),
                react_1.default.createElement("p", { className: "modal-text" }, "Hiermee verwijder je het aanbod definitief voor iedereen."),
                react_1.default.createElement("div", { className: "modal-actions" },
                    react_1.default.createElement(Button_1.default, { onClick: function () { return setIsOpen(false); } },
                        react_1.default.createElement("span", null, "Annuleren")),
                    react_1.default.createElement(Button_1.default, { className: "secondary", onClick: deleteHit },
                        react_1.default.createElement("span", null, "Verwijderen")))))));
};
exports.default = SportsOfferTable;
